export const AUTH_RECAPTCHA_FAILED_MESSAGE = "auth_recaptcha_failed";

export const AUTH_NATIVE_RECAPTCHA_OPTIONS = {
  hideBadge: true
};
